export const initCaravanStorage = () => {
    if (window.litePickerRangeField) {
        // window.litePickerRangeField.
        // console.log('window.location', window.location.pathname);
        setLockDaysForType(0);

        const optionField = $("[name='StorageOptionID']");
        optionField.on('change', function(e) {
            // console.log('change!', optionField.val());
            setLockDaysForType(optionField.val());
        });

        const startDate = $("#CaravanStorageForm_CaravanStorageForm_StartDate");
        console.log('startDate', startDate);
        startDate.on('change', function(e) {
            console.log('startDate change', startDate.val());
        });
        // // console.log('window.litePickerRangeField', window.litePickerRangeField);
        // // $(window.litePickerRangeField.picker).on('preselect', (date1, date2) => {
        // //     console.log('selected a date');
        // //     $('#CaravanStorageForm_CaravanStorageForm_User_Holder').removeClass('hidden');
        // // });
    }
}

function setLockDaysForType(typeId)
{
    const url = `${window.location.pathname}/getLockedDates/${typeId}`
    $.ajax({ url, success: function( response ) {
        const jsonRes = JSON.parse(response);
        console.log('jsonRes', jsonRes);
        window.litePickerRangeField.setDate(jsonRes.availableFrom);
        window.litePickerRangeField.setLockDays(jsonRes.lockDays);
    }});
}